import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { NotificationService } from '../services';
import { NOTIFICATION_COUNT_KEY } from '../constants/query';
import { INotificationCount } from 'modules/sales/settings/order-status/interfaces/INotification';

export const useNotificationCount = (config?: { enabled?: boolean }) => {
  const { enabled = true } = config || {};

  const { data, isLoading, isError, error, refetch } = useQuery<INotificationCount>({
    queryKey: [NOTIFICATION_COUNT_KEY],
    queryFn: () => NotificationService.getNotificationCount(),
    enabled,
    staleTime: 2 * 60 * 1000,
    cacheTime: 5 * 60 * 1000,
  });

  const count = useMemo<INotificationCount>(() => {
    if (!data) {
      return { total: 0, notifications: 0, exports: 0 };
    }
    return {
      total: data.total || 0,
      notifications: data.notifications || 0,
      exports: data.exports || 0,
    };
  }, [data]);

  return {
    count,
    isLoading,
    isError,
    error,
    refetch,
  };
};
